import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import SuccessSvg from "@icons/myicons/check-circle-filled.svg?react";
import { CenterScreen } from "@components";

export const SuccessStep = ({ backUrl }: { backUrl: string }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <CenterScreen>
      <Box
        data-testid="success-step"
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        maxWidth={800}
        px={4}
      >
        <SuccessSvg
          width="40px"
          height="40px"
          color={theme.palette.icon.success}
        />
        <Typography variant="h2" mt={2} mb={5}>
          {t("depotTransfer.successStep.message")}
        </Typography>
        <Button
          data-testid="back-button"
          variant="primary"
          onClick={() => navigate(backUrl)}
        >
          {t("depotTransfer.successStep.finishButton")}
        </Button>
      </Box>
    </CenterScreen>
  );
};
